if(!window.theme._registeredSections['shop-the-look'] === true){
  theme.ShopTheLook = (function() {
    const selectors = {
      parentElement: '[data-shop-the-look]',
      blocks: '[data-stl-blocks]',
      modal: '[data-stl-modal]',
      modalContent: '[data-stl-modal-content]',
      modalClose: '[data-stl-modal-close]',
      modalTrigger: '[data-stl-modal-trigger]',
      stlProducts: '[data-stl-products]',
      stlIndicator: '[data-stl-indicator]',
      productList: '.shop-the-look__product-list',
      productAddButton: '[data-stl-product-add]',
      variantPicker: '[data-stl-variant-picker]',
      variantAddButton: '[data-stl-variant-add]'
    }; 

    function ShopTheLook() {
      const parents = document.querySelectorAll(selectors.parentElement);

      if (!parents.length) { return; }

      parents.forEach(parent => {
        const modal = document.querySelector(selectors.modal);
        const modalContent = modal.querySelector(selectors.modalContent);
        const modalTriggers = [...parent.querySelectorAll(selectors.modalTrigger)];
        const blocksContainer = parent.querySelector(selectors.blocks);

        if (!blocksContainer) { return; }

        const isCarousel = blocksContainer.hasAttribute('data-stl-carousel');

        if (isCarousel) {
          const slider = $(blocksContainer);

          slider.not('.slick-initialized').slick({
            arrows: false,
            dots: true,
            touchMove: true,
            slidesToShow: 3,
            slidesToScroll: 3,
            rows: 0,
            responsive: [
              {
                breakpoint: Number(theme.settings.grid_medium),
                settings: {
                  dots: true,
                  infinite: true,
                  slidesToShow: 1,
                  slidesToScroll: 1,
                }
              }
            ]
          });
        }

        function addItemToCart(target) {
          const variantId = Number(target.dataset.variantId);
          if (!variantId) { return; }

          const items = [{
            id: variantId,
            quantity: 1
          }];

          fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({items})
          })
            .then(() => window.theme.sideCart.refreshCart())
            .then(() => window.theme.sideCart.openDrawer())
            .catch(err => console.error(err));
        }

        function setupCtaEventListeners(ctas) {
          ctas.forEach(cta => {
            cta.addEventListener('click', (evt) => {
              const variantSelector = cta.nextElementSibling;
              if (variantSelector) {
                // If next sibling exists, assume it's variant selector and display Variant Selector UI
                cta.nextElementSibling.classList.remove('hide');
                cta.classList.add('hide');

                const variantAddButtons = variantSelector.querySelectorAll(selectors.variantAddButton);
                variantAddButtons.forEach(variantAdd => {
                  variantAdd.addEventListener('click', (variantEvent) => {
                    addItemToCart(variantEvent.target);
                  });
                });
              } else {
                // If no next siblings, then this product has only 1 variant, so just add it to cart
                addItemToCart(evt.target);
              }
            });
          });
        }

        function handleIndicatorHover(indicators, parentModal) {
          if (!indicators.length) return;

          indicators.forEach(indicator => {
            indicator.addEventListener('mouseenter', (event) => {
              const productTargetRef = event.target.attributes.href.value;
              const productTarget = parentModal.querySelector(productTargetRef);
              if (productTarget) {
                productTarget.classList.add('stl-product--highlight');
              }
            });

            indicator.addEventListener('mouseleave', (event) => {
              const productTargetRef = event.target.attributes.href.value;
              const productTarget = parentModal.querySelector(productTargetRef);
              if (productTarget) {
                productTarget.classList.remove('stl-product--highlight');
              }
            });
          });
        }

        function populateStlModal(elementToClone) {
          const modalHeaderClone = modal.querySelector('header').cloneNode(true);
          const stlProductsClone = elementToClone.cloneNode(true);
          modalHeaderClone.classList.add('large-only');
          modalContent.innerHTML = '';
          modalContent.appendChild(stlProductsClone);
          const stlProducts = modalContent.querySelector(selectors.stlProducts);
          const productList = stlProducts.querySelector(selectors.productList);
          productList.appendChild(modalHeaderClone);
          stlProducts.classList.remove('hide');
          stlProducts.classList.add('shop-the-look__products');

          // Store the currently focused element
          window.theme.lastActiveElement = document.activeElement;

          document.body.classList.add('shop-the-look__modal-visible');
          modal.classList.add('modal-is-visible');
          modal.setAttribute('aria-hidden', 'false');

          // Set focus to the modal for accessibility
          const modalCloseButton = modal.querySelector('[data-stl-modal-close]');
          if (modalCloseButton) {
            modalCloseButton.focus();
          }

          // Close on ESC pressed
          $(document).on('keydown:escape', hideStlModal);

          const modalIndicators = modal.querySelectorAll(selectors.stlIndicator);
          const modalCtas = modal.querySelectorAll(selectors.productAddButton);
          handleIndicatorHover(modalIndicators, modal);
          setupCtaEventListeners(modalCtas);
        }

        function showStlModal(trigger, isSlickSlider = false) {
          if (isSlickSlider) {
            // Slick Slider will trigger click events attached to slide children when slider is being dragged
            // using below method fixes that behaviour (https://github.com/kenwheeler/slick/issues/1015)
            $(blocksContainer).on('click', '.shop-the-look__modal-trigger', function(event) {
              populateStlModal(event.currentTarget.nextElementSibling);
            });
          } else {
            trigger.addEventListener('click', () => {
              populateStlModal(trigger.nextElementSibling);
            });
          }
        }

        function hideStlModal(evt) {
          if (!evt.target.hasAttribute('data-stl-modal-close') && evt.type !== 'keydown:escape') { return; }

          // Remove escape event listener
          $(document).off('keydown:escape', hideStlModal);

          if (window.theme.lastActiveElement) {
            window.theme.lastActiveElement.focus();
            window.theme.lastActiveElement = null;
          }
          modal.setAttribute('aria-hidden', 'true');
          modal.classList.remove('modal-is-visible');
          document.body.classList.remove('shop-the-look__modal-visible');
        }

        modal.addEventListener('click', hideStlModal);
        modalTriggers.forEach(trigger => showStlModal(trigger, isCarousel));
      });
    }
    return ShopTheLook;
  })();
  window.theme.sections.register('shop-the-look', theme.ShopTheLook);
  window.theme._registeredSections['shop-the-look'] = true;
}
